import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
export default function Hero() {
  return (

    <div className='w-full bg-[#8a6e5a] '>
      <div className="w-full h-[720px] md:h-[656px] relative overflow-hidden bg-[#EFEBE4]">
        {/* Background Video */}
        <div className="absolute inset-0 w-full h-full">
          <video
            className="w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          >
            <source
            src="https://player.vimeo.com/progressive_redirect/playback/1119780896/rendition/720p/file.mp4?loc=external&signature=63672524f17754b242b82481b79afd33def5513206e6b37eb4a026b169ab1f6d"
              // src="https://framerusercontent.com/assets/RDQGql1a4Ox6yNHkaWijZ8yGcI.mp4"
              //src="/static/videos/hero.mp4"
              type="video/mp4" />
            {/* Fallback image if video doesn't load */}
            <div className="w-full h-full bg-gradient-to-br " />
          </video>
          {/* Overlay for better text readability */}
          <div
            className="absolute inset-0"
          // className="absolute inset-0 bg-black/20" 
          />
        </div>

        {/* Desktop Content */}
        <div className="hidden md:block relative z-10 w-full h-full flex items-start pt-[106px]">
          <div className="w-[560px] ml-[118px] flex flex-col justify-start items-start gap-8">
            <div className="self-stretch flex flex-col justify-start items-start gap-4">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch justify-start text-white text-5xl font-medium font-['Lora'] leading-[56px]">
                  Join Us Where Faith Meets Finance &
                </div>
                <div className="self-stretch justify-start text-white text-5xl font-medium font-['Lora'] leading-[56px]">
                  Become a Certified
                </div>
                <div className="pr-0.5 inline-flex justify-start items-start gap-0.5">
                  <div className="justify-start text-white text-5xl font-medium font-['Lora'] leading-[56px]">
                    Kingdom Advisor
                  </div>
                  <div className="justify-start text-white text-xl font-medium font-['Lora'] leading-[56px]">
                    ®
                  </div>
                </div>
              </div>
              <div className="w-[465.43px] justify-start text-white text-lg font-normal font-['Instrument-Sans'] leading-7">
                Get the designation that&apos;s the gold standard for Christian financial advisors.
              </div>
            </div>

            <div className='w-full flex justify-start items-center'>
              <Link href="https://app.kingdomadvisors.com/cka" target='_blank' rel='noopener noreferrer'>
                <div className="w-full md:w-auto px-8 py-4 bg-[#FBB35C] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#FBB35C] transition-colors cursor-pointer">
                  <div className="w-6 h-6 relative">
                    <Image
                      src="/static/images/cka_landing/blue_arrows.svg"
                      alt="Arrow"
                      width={24}
                      height={24}
                    />
                  </div>
                  <div className="justify-start text-blue-950 text-base font-medium font-['Instrument-Sans']">
                    Get Certified
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Content */}
        <div className="md:hidden relative z-10 w-full h-full px-4 flex flex-col justify-end items-start gap-2.5 ">
          <div className="self-stretch flex flex-col justify-start items-start gap-8">
            <div className="self-stretch flex flex-col justify-start items-start gap-4">
              <div className="self-stretch flex flex-col justify-start items-start">
                <div className="self-stretch justify-start text-white text-3xl font-medium font-['Lora']">
                  Join Us Where Faith 
                </div>
                <div className="self-stretch justify-start text-white text-3xl font-medium font-['Lora']">
                    Meets Finance &
                </div>
                <div className="self-stretch justify-start text-white text-3xl font-medium font-['Lora']">
                  Become a Certified
                </div>
                <div className="self-stretch inline-flex justify-start items-start gap-0.5">
                  <div className="flex-1 justify-start">
                    <span className="text-white text-3xl font-medium font-['Lora']">Kingdom Advisor</span>
                    <sup style={{ fontSize: '18px' }} className="text-white text-3xl font-medium font-['Lora']">®</sup>
                  </div>
                </div>
              </div>
              <div className="self-stretch justify-start text-white text-base font-normal font-['Instrument-Sans'] leading-normal">
                Get the designation that&apos;s the gold standard for Christian financial advisors.
              </div>
            </div>


            <div className='w-full md:px-4 flex justify-center items-center mb-4 ' >
            <Link className='w-full' href="https://app.kingdomadvisors.com/cka" target='_blank' rel='noopener noreferrer'>
              <div className="w-full md:w-auto px-8 py-4 bg-[#FBB35C] rounded inline-flex justify-center items-center gap-2.5 hover:bg-[#FBB35C] transition-colors cursor-pointer">
                <div className="w-6 h-6 relative">
                  <Image
                    src="/static/images/cka_landing/blue_arrows.svg"
                    alt="Arrow"
                    width={24}
                    height={24}
                  />
                </div>
                <div className="justify-start text-blue-950 text-base font-medium font-['Instrument-Sans']">
                  Get Certified
                </div>
              </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}